import React, { memo, useCallback, useContext } from "react";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

type ChooseScheduleTypeProp = {
  setSchduleType: Function;
  setStep: Function;
};

const ChooseScheduleType = ({ setSchduleType, setStep }: ChooseScheduleTypeProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { chooseServiceTypePop: false },
    });
  }, []);

  const clickType = (type: string) => () => {
    setSchduleType(type);
    if (type === "APPOINTMENT") {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CHOOSE_MEMBER_PASS_POP",
        open: { chooseMemberPassPop: true },
      });
    } else if (type === "OT") {
      dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_MEMBER_POP", open: { chooseMemberPop: true } });
    } else if (type === "CS") {
      dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_MEMBER_POP", open: { chooseMemberPop: true } });
    } else if (type === "ET") {
      dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_DATE_POP", open: { chooseDatePop: true } });
    }
    setStep(2);
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.chooseServiceTypePop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="스케줄 유형 선택" onClose={handleClose} />
      <div className="picker-body choose-schedule-type-pop">
        <div className="choose-schedule-type" onClick={clickType("APPOINTMENT")}>
          <div className="text">개인레슨</div>
        </div>
        <div className="choose-schedule-type" onClick={clickType("OT")}>
          OT
        </div>
        <div className="choose-schedule-type" onClick={clickType("CS")}>
          상담
        </div>
        <div className="choose-schedule-type" onClick={clickType("ET")}>
          기타
        </div>
      </div>
    </Drawer>
  );
};

export default memo(ChooseScheduleType);
